










import { Component, Vue } from 'vue-property-decorator'

import NoRetoggleCollapse from '@/components/NoRetoggleCollapse.vue'

@Component({
  components: {
    NoRetoggleCollapse,
  },
  inheritAttrs: false,
})
export default class StepAccordionShell extends Vue {}
